import { InternetProductResponseService } from './../../../order-api-response/internet-pd-response.service';
import { computed, inject, Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../../base-workflow-state.service';
import { VideoFlowStateService } from '../video-flow-state.service';
import { VideoProductResponseService } from '../../../order-api-response/video-pd-response.service';
import { VideoAdditionalChannelFormData, VideoAdditionalChannelOfferData, VideoClosingOffersData } from '../../../../../../../models/order/workflow/video/video-additional-offer.model';
import { isClosingOfferGroup } from '../../../../../../../constants/app-constants';



@Injectable({ providedIn: 'root' })
export class ClosingOffersStateService extends BaseWorkflowStateService<VideoClosingOffersData> {
    private flowStateService = inject(VideoFlowStateService);
    private videoPdResponseService = inject(VideoProductResponseService);
    private internetPdResponseService = inject(InternetProductResponseService);
    override stateKey: string = 'videoClosingOffers';

    internetCustomizations = computed(() => this.internetPdResponseService.getCustomizations()?.filter(cust =>
        isClosingOfferGroup(cust.customization.DetailedGroupName)
    ) || []);

    videoCustomizations = computed(() => this.videoPdResponseService.getCustomizations()?.filter(cust =>
        cust.customization.DetailedGroupName === 'ClosingOffers' ||
        cust.customization.DetailedGroupName === 'ClosingOptionalOffers' || 
        cust.customization.DetailedGroupName === 'ClosingAdditionalOffers'
    ) || []);

    offers = computed(() => {
        return [(this.state()?.closingOffers?.offers || [])].flat();
    });

    closingAdditionalOffers = computed(() => {
        return [(this.state()?.closingAdditionalOffers?.offers || [])].flat();
    });

    addDefaultClosingAdditionalOffer() {
        if (this.state()?.closingAdditionalOffers) return;
        const closingAdditionalCustomizations = this.videoCustomizations().find(cust =>
            cust.customization.DetailedGroupName === 'ClosingOptionalOffers' ||
            cust.customization.DetailedGroupName === 'ClosingAdditionalOffers'
        );
        if (closingAdditionalCustomizations) {
            const selectedChoices = closingAdditionalCustomizations.customization.Choices?.Choice?.filter(choice => choice.DefaultSelected) || [];
            if (selectedChoices.length > 0) {
                const defaultOffer: VideoAdditionalChannelFormData = {
                    offers: selectedChoices.map(choice => ({
                        choiceCode: choice.ChoiceCode,
                        accepted: true,
                        requiredInput: false
                    } as VideoAdditionalChannelOfferData)),
                    reviewed: false,
                    customizationCode: closingAdditionalCustomizations.customization.CustomizationCode
                }
                const currentState = this.state() || { closingOffers: null, closingAdditionalOffers: null };
                currentState.closingAdditionalOffers = defaultOffer;
                this.updateData(currentState);
            }
        }
    }

    addDefaultClosingOffer() {
        if (this.state()?.closingOffers) return;
        const closingCustomizations = this.videoCustomizations().find(cust => cust.customization.DetailedGroupName === 'ClosingOffers');
        if (closingCustomizations) {
            const selectedChoices = closingCustomizations.customization.Choices?.Choice?.filter(choice => choice.DefaultSelected) || [];
            if (selectedChoices.length > 0) {
                const defaultOffer: VideoAdditionalChannelFormData = {
                    offers: selectedChoices.map(choice => ({
                        choiceCode: choice.ChoiceCode,
                        accepted: true,
                        requiredInput: false
                    } as VideoAdditionalChannelOfferData)),
                    reviewed: false,
                    customizationCode: closingCustomizations.customization.CustomizationCode
                }
                const currentState = this.state() || { closingOffers: null, closingAdditionalOffers: null };
                currentState.closingOffers = defaultOffer;
                this.updateData(currentState);
            }
        }
    }

    findOfferChoiceCode(choiceCode: string) {
        return this.offers().find(offer => offer?.choiceCode === choiceCode) || this.closingAdditionalOffers().find(offer => offer?.choiceCode === choiceCode);
    }

    protected override saveLocalDraft(): void {
        this.flowStateService.updateData({ [this.stateKey]: this.state() });
    }

    resetData() {
        this.state.set(null);
        this.saveLocalDraft();
    }
}
